import { colors } from "assets/styles/colors";
import styled from "styled-components";

export const CommonContainer = styled.div`
    min-height: 40vh;
    max-height: 65vh;
    overflow-y: auto;
    padding: 0 20px 20px 20px;
`